import { render, staticRenderFns } from "./DocumentEditorWorkspace.vue?vue&type=template&id=2c3f5409&scoped=true"
import script from "./DocumentEditorWorkspace.vue?vue&type=script&lang=js"
export * from "./DocumentEditorWorkspace.vue?vue&type=script&lang=js"
import style0 from "./DocumentEditorWorkspace.vue?vue&type=style&index=0&id=2c3f5409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3f5409",
  null
  
)

export default component.exports